/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Cell, ColumnInterface } from 'react-table';

import { getSortablePeriodLabels } from '@trqk/utils';

import { defaultCellWidth } from '../constants';

interface Props<D extends object> {
    cell: Cell<D>;
    column: ColumnInterface<D>;
}

const defaultResult = 'None';

/**
 * Displays a statement period with the year first, like '2019 Q2'
 * @param Props must contain a `cell.value` which is a ProStatementPeriod
 */
export function StatementPeriodCell<D extends object>({
    cell,
    column,
}: Props<D>): JSX.Element | string {
    const value = cell?.value as StatementPeriod;

    if (value === null) {
        return defaultResult;
    }

    const sortablePeriodLabels = getSortablePeriodLabels(value);

    if (sortablePeriodLabels.short !== null) {
        return sortablePeriodLabels.short;
    }

    if (sortablePeriodLabels.long !== null) {
        const width = (column?.width as number) ?? defaultCellWidth;

        return (
            <div className="flex items-center">
                <div
                    className="respond-to-mouse leading-tight clamp-2-lines"
                    style={{
                        width,
                    }}
                >
                    {sortablePeriodLabels.long}
                </div>
            </div>
        );
    }

    return defaultResult;
}
